import { useForm } from 'react-hook-form';
import gYupResolver from '../../../components/technical/form/gYupResolver';
import * as yup from 'yup';
import { updateWidgetState, useWidgetState } from '../../../components/management/customDashboard/CustomWidgetContext';
import { FormPortfolioFilters } from '../../technical/form/FormPortfolioFilters';
import WidgetSettings from '../../../components/management/customDashboard/WidgetSettings';
import type { PortfolioTileSettingsState } from '../../../components/portfolio/dashboard/tiles/PortfolioTileSettings';
import {
  type PortfolioFilters,
  portfolioFiltersSchema,
} from 'components/technical/PortfolioFilterDrawer/UsePortfolioFilters';

const schema = yup
  .object({
    title: yup.string().required(),
  })
  .concat(portfolioFiltersSchema);

export interface PositionSummaryLightSettingsState extends Partial<PortfolioFilters> {
  title: string;
}

export const PositionSummaryLightSettings = ({
  id,
  onFinishedEditing,
  onRemovedWidget,
}: {
  id: string;
  onFinishedEditing: () => void;
  onRemovedWidget: () => Promise<void>;
}) => {
  const initialState = useWidgetState<PortfolioTileSettingsState>(id);
  const updater = updateWidgetState<PortfolioTileSettingsState>();

  const methods = useForm<PortfolioTileSettingsState>({
    resolver: gYupResolver(schema),
    defaultValues: {
      ...initialState,
    },
  });

  const handleFormSubmit = async (input: PortfolioTileSettingsState): Promise<void> => {
    await updater({
      id,
      state: {
        ...input,
        title: input.title,
      },
      updateBackend: true,
    });

    onFinishedEditing();
  };

  return (
    <WidgetSettings methods={methods} handleFormSubmit={handleFormSubmit} onRemovedWidget={onRemovedWidget}>
      <FormPortfolioFilters />
    </WidgetSettings>
  );
};
